import { render, staticRenderFns } from "./travelRelatedPersonnel.vue?vue&type=template&id=9fdbdd54&scoped=true"
import script from "./travelRelatedPersonnel.vue?vue&type=script&lang=js"
export * from "./travelRelatedPersonnel.vue?vue&type=script&lang=js"
import style0 from "./travelRelatedPersonnel.vue?vue&type=style&index=0&id=9fdbdd54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdbdd54",
  null
  
)

export default component.exports